import axios from "axios";

export const state = {
    deathcertificates: [],
};

export const getters = {
    deathcertificates: state => state.deathcertificates,
};

export const mutations = {
    setCertificates(state, newValue) {
        state.deathcertificates = newValue
    },
};

export const actions = {
    fetchDeathCertificates({ commit }, params = {}) {
        return axios.get('/deathcertificates', { params }).then(res => {
            commit('setCertificates', res.data.certificates)
            return res;
        })
    },
};
